import { deduplicate, isNetworkError } from '$lib/utils';
import { get, readonly, writable, type Writable } from 'svelte/store';
import { type ProductCardMissingInfo$result, ProductCardMissingInfoStore } from '$houdini';
import { browser } from '$app/environment';
import { languageStore } from '$lib/store/language.store';
import { addSDS, trimSDS } from '$lib/utils/sds';
import { ensureCountry, ensureLocale } from '$lib/utils/i18n';

export const createProductFetcherStore = (...handles: string[]) => {
	const fetchProducts = (data: string[]) => {
		const toRequest = deduplicate(data);
		const result: Writable<
			{
				data: {
					product: ProductCardMissingInfo$result | null;
					sku: string;
				} | null;
			}[]
		> = writable(toRequest.map(() => ({ data: null })));
		if (!browser) {
			return readonly(result);
		}

		let i = 0;
		for (const item of toRequest) {
			const store = new ProductCardMissingInfoStore();
			const localI = Number(i);
			store
				.fetch({
					variables: {
						handle: trimSDS(item),
						sdsHandle: addSDS(item),
						language: ensureLocale(get(languageStore).locale),
						country: ensureCountry(get(languageStore).country)
					}
				})
				.then(({ data }) => {
					if (data?.product) {
						const sku = data?.product?.variants.edges[0].node.sku;

						result.update((current) => {
							const changeset = [...current];
							changeset[localI] = {
								data: {
									product: data,
									sku: sku?.value || ''
								}
							};
							return changeset;
						});
					}
				})
				.catch((e) => {
					if (isNetworkError(e)) {
						// TODO: Implement retry logic
						return;
					} else {
						throw e;
					}
				});

			i++;
		}

		return readonly(result);
	};

	return fetchProducts(handles);
};
